class Zoomer {

    constructor() {


        this.page = document.querySelector('.zoomer .page');
        this.page.addEventListener("mousemove", (event) => this.zoomerOnMove(event));
        this.page.addEventListener("mouseleave", (event) => this.zoomerOnOut(event));

        document.querySelector('.zoomer .tip').style.display = 'block';

        this.zoomerSmall = document.querySelector('.zoomer .small-zoom');
        this.zoomerSmall.addEventListener("mousemove", (event) => this.preventMoveEvent(event));

        this.preview = document.querySelector('.zoomer .preview-zoom');
        this.preview.addEventListener("mousemove", (event) => this.preventMoveEvent(event));
    }

    zoomerOnMove(e) {
        var aspect = 2.344;
        var zoomLensSize = 150;
        var centerOffert = zoomLensSize / 2;

        if (! this.zoom1) {
            this.zoom1 = document.querySelector('.zoomer .small-zoom');
            this.zoom2 = document.querySelector('.zoomer .preview-zoom');
        }
        if (!this.zoom1.style.display) {
            this.zoom1.style.display = 'block';
        }
        if (!this.zoom2.style.display) {
            this.zoom2.style.display = 'block';
        }

        this.zoom1.style.left = (e.offsetX - centerOffert ) + 'px';
        this.zoom1.style.top = (e.offsetY - centerOffert) + 'px';

        var bgX = -1 * (e.offsetX * aspect - centerOffert * aspect );
        var bgY = -1 * (e.offsetY  * aspect - centerOffert * aspect  );

        this.zoom2.style.backgroundPosition = bgX + 'px ' + bgY + 'px';


    }
    preventMoveEvent(event) {
        event.stopPropagation(); 

    }
    zoomerOnOut() {

        this.zoom1.style.display = '';
        this.zoom2.style.display = '';
    }
}
